import { Injectable, Injector } from '@angular/core';
import { AyrCommentsModel } from '../model/ayr-comments.model';
import { AyrNewsModel } from '../model/ayr-news.model';
import { AyrSeenModel } from '../model/ayr-seen.model';

@Injectable({
  providedIn: 'root',
})
export class HomeService {
  constructor(private injector: Injector) {}

  seenImagesBuilder(): AyrSeenModel[] {
    let list: AyrSeenModel[] = [];

    let smartCities: AyrSeenModel = {
      title: 'Smart Cities New York',
      href: 'https://smart-cities.pt/',
      alt: 'Navigate to Smart Cities webpage',
      srcLight:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/home/logos/smart.svg',
      srcDark:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/logos/smart.svg',
      class: '',
    };
    let cop26: AyrSeenModel = {
      title: 'COP26',
      href: 'https://ukcop26.org/',
      alt: 'Navigate to COP 26th edition webpage',
      srcLight:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/home/logos/cop_light_min.webp',
      srcDark:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/home/logos/cop_dark_min.webp',
      class: 'cop',
    };
    let mobiSummit: AyrSeenModel = {
      title: 'Portugal Mobi Summit',
      href: 'https://www.scnyurbantech.com/',
      alt: 'Navigate to Portugal Mobi Summit webpage',
      srcLight:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/home/logos/mobi_light.webp',
      srcDark:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/home/logos/mobi_dark.webp',
      class: 'mobi',
    };
    let glexSummit: AyrSeenModel = {
      title: 'GLEX Summit Portugal',
      href: 'https://www.glexsummit.com/',
      alt: 'Navigate to GLEX Summit webpage',
      srcLight:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/home/logos/GLEX_Logo_black@2x.webp',
      srcDark:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/home/logos/GLEX_Logo_white@2x.webp',
      class: 'glex',
    };

    list.push(smartCities);
    list.push(cop26);
    list.push(mobiSummit);
    list.push(glexSummit);

    return list;
  }

  commentsBuilder(): AyrCommentsModel[] {
    let list: AyrCommentsModel[] = [];
    let one: AyrCommentsModel = {
      alt: 'Google.org logo',
      active: true,
      author: 'Rowan Barnett',
      authorRole: 'author_role_head',
      comment:
        '... citizens, communities and companies are rewarded for their sustainable mobility behaviours. This establishes the first stepping stone for the deployment of local voluntary carbon markets. We are thrilled to support CEiiA with a grant to further develop the AYR platform, and look forward to working closely with this team.',
      companyImage:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/home/logos/google_with_background.png',
      title:
        'AYR is a successful applicant to the Google.org Impact Challenge on Climate.',
    };
    let two: AyrCommentsModel = {
      alt: 'New Bauhaus Europe logo',
      active: true,
      author: 'Mariya Gabriel',
      authorRole: 'author_role_european_commisioner',
      comment:
        '... by creating bridges between science and innovation and art and culture and by taking a holistic approach, the New European Bauhaus will develop solutions that are not only sustainable and innovative, but also accessible and enriching for all. These winning designs embody this new spirit of the New European Bauhaus.',
      companyImage:
        'https://storage.googleapis.com/weayr-assets-non-prod/images/home/logos/bauhaus.webp',
      title: '[AYR] Embody this new spirit of the New European Bauhaus.',
    };

    list.push(one);
    list.push(two);

    return list;
  }

  newsBuilder(): AyrNewsModel[] {
    let list: AyrNewsModel[] = [];

    let thirteen: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'CEiiA leva AYR ao Festival New European Bauhaus',
      description:
        'O AYR – serviço de sustentabilidade desenvolvido pelo CEiiA que recompensa pessoas e comunidades pela não emissão de CO2 – vai estar em destaque em Bruxelas, entre os dias 9 e 12 de junho.',
      tag: 'EVENTS',
      date: '2022-06-09T19:07:00.000+09:00',
      link: 'https://www.ambientemagazine.com/ceiia-leva-servico-ayr-ao-festival-new-european-bauhaus/',
    };

    let twelve: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'AYR @COP26 em Glasgow',
      description:
        "AYR sustainability platform was featured at @COP26, in the session about “Pricing Carbon to Support a Transition to Net Zero”. Watch CEiiA's participation …",
      tag: 'EVENTS',
      date: '2021-11-04T19:07:00.000+09:00',
      link: 'https://www.linkedin.com/posts/ceiia---center-for-innovation-and-creative-engineering_ceiiacop26-activity-6862349618211028992-muV_',
    };
    let eleven: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'AYR vence New European Bahaus',
      description:
        'A plataforma AYR, desenvolvida pelo Centro de Engenharia e Desenvolvimento de Produto (CEiiA) em Matosinhos, venceu o prémio New European Bauhaus na categoria de produtos e estilo de vida sustentáveis.',
      tag: 'NEWS',
      date: '2021-09-16T14:48:00.000+09:00',
      link: 'https://eco.sapo.pt/2021/09/16/projeto-de-matosinhos-vence-premio-new-european-bauhaus/',
    };
    let ten: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'CEiiA vai trabalhar com a Google',
      description:
        'O CEiiA foi selecionado pela Google para integrar o programa "Impact Challenge on Climate" com a plataforma de sustentabilidade AYR, baseada em "blockchain", e que recompensa comportamentos neutros em carbono na mobilidade.',
      tag: 'NEWS',
      date: '2021-04-13T14:48:00.000+09:00',
      link: 'https://www.jornaldenegocios.pt/empresas/tecnologias/detalhe/google-escolhe-ceiia-para-aplicar-o-portugues-ayr-nos-quatro-cantos-do-mundo',
    };
    let nine: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'Comprar um café com AYR',
      description:
        'Comprar um café com emissões de CO2 poupadas em atividades do dia-a-dia será uma possibilidade a muito breve trecho. O CEIIA  ...',
      tag: 'NEWS',
      date: '2019-07-04T14:48:00.000+09:00',
      link: 'https://www.ceiia.com/single-post/2018/02/15/AYR-CREDIT-COMPRAR-UM-CAF%C3%89-COM-EMISS%C3%95ES-DE-CO2-POUPADAS-EM-ATIVIDADES-DO-DIA-A-DIA',
    };
    let eight: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'Trotinete gera moeda virtual',
      description:
        'As trotinetes elétricas que começaram a circular nesta segunda-feira em Matosinhos estão integradas num sistema que permitirá quantificar, valorizar …',
      tag: 'NEWS',
      date: '2019-05-27T14:48:00.000+09:00',
      link: 'https://www.jn.pt/local/noticias/porto/matosinhos/quem-andar-de-trotinete-em-matosinhos-vai-ganhar-dinheiro-virtual-10947842.html',
    };
    let seven: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'Plataforma AYR do CEiiA',
      description:
        '300 trotinetes elétricas integram a partir de hoje a plataforma AYR desenvolvida pelo Centro de Engenharia e Desenvolvimento de Produto (CEiiA) ...',
      tag: 'NEWS',
      date: '2019-05-27T14:48:00.000+09:00',
      link: 'https://www.cm-matosinhos.pt/pages/242?news_id=6234',
    };
    let six: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'AYR vai ser testado em Nova Iorque',
      description:
        "Aplicação 'Ayr', desenvolvida em Portugal, de contabilização de reduções de emissões de dióxido de carbono (CO2), vai começar a operar no último …",
      tag: 'NEWS',
      date: '2019-05-21T14:48:00.000+09:00',
      link: 'https://www.dinheirovivo.pt/empresas/ayr-app-portuguesa-para-medir-emissoes-de-co2-vai-ser-testada-em-nova-iorque-12805108.html',
    };
    let five: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'AYR chega a Nova Iorque',
      description:
        'Centro de Matosinhos mostra primeiro sistema de sustentabilidade mundial que cria moeda local, os AYR, para premiar quem emite menos CO2 …',
      tag: 'NEWS',
      date: '2019-05-11T14:48:00.000+09:00',
      link: 'https://insider.dn.pt/featured/ceiia-apresenta-em-nova-iorque-sistema-que-nos-paga-para-ajudar-a-terra/',
    };
    let four: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'AYR é a nova “moeda” para sustentabilidade',
      description:
        'A sua opção em reduzir a taxa de carbono vai passar a ter um valor. Ao trocar o carro pela bicicleta pode pode ganhar créditos AYR que pagam a próxima ...',
      tag: 'NEWS',
      date: '2019-05-10T14:48:00.000+09:00',
      link: 'https://visao.sapo.pt/atualidade/2019-05-10-AYR-e-a-nova-moeda-para-a-sustentabilidade/',
    };
    let three: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'CEiiA lança OPT mundial de carbono',
      description:
        'Depois de, ainda recentemente, o trabalho que desenvolve na área da mobilidade sustentável ter sido reconhecido pela ONU como como um caso de estudo …',
      tag: 'NEWS',
      date: '2019-05-10T14:48:00.000+09:00',
      link: 'https://www.jornaldenegocios.pt/empresas/tecnologias/detalhe/portugues-ceiia-lanca-opt-mundial-de-carbono-em-nova-iorque',
    };
    let two: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'UberGREEN salta de Matosinhos',
      description:
        'O uberGREEN, vai ser lançado em janeiro de 2018 a nível mundial pelo Centro para a Excelência e Inovação da Indústria Automóvel (CEiiA) ...',
      tag: 'NEWS',
      date: '2016-10-28T19:07:00.000+09:00',
      link: 'https://observador.pt/2016/10/28/servico-ubergreen-salta-de-matosinhos-para-o-resto-do-mundo-em-2018/',
    };
    let one: AyrNewsModel = {
      active: true,
      platform: true,
      title: 'Teste eléctrico da Uber em Portugal',
      description:
        'Serviço que avançou com tecnologia do CEIIA e funcionava apenas em Lisboa e no Porto vai ser expandido a todos os países onde opera a Uber ...',
      tag: 'NEWS',
      date: '2016-10-16T19:07:00.000+09:00',
      link: 'https://www.publico.pt/2016/10/28/economia/noticia/teste-electrico-da-uber-em-portugal-vai-ser-alargado-a-escala-global-1749273',
    };

    list.push(thirteen);
    list.push(twelve);
    list.push(eleven);
    list.push(ten);
    list.push(nine);
    list.push(eight);
    list.push(seven);
    list.push(six);
    list.push(five);
    list.push(four);
    list.push(three);
    list.push(two);
    list.push(one);

    return list;
  }
}
